export const QP_ANALYTICS_EVENTS = [
  'playback_request',
  'playback_error',
  'app_error',
  'create_profile',
  'update_profile',
  'app_start',
  'app_foreground',
  'app_background',
  'sign_up',
  'subscription_initiated',
  'purchase_subscription',
  'change_subscription',
  'payment_initiated',
  'login',
  'logout',
  'user_error',
  'download_request',
  'download_prepared',
  'download_started',
  'download_paused',
  'download_resumed',
  'download_stopped',
  'download_completed',
  'download_deleted',
  'download_error',
];
